import { INIT_DAILY_REPORT_REQUEST, SET_DAILY_REPORT, ERROR_DAILY_REPORT, INIT_YEARLY_REPORT_REQUEST, SET_YEARLY_REPORT, ERROR_YEARLY_REPORT } from './action';

const initialState = {
    isLoading: false,
    error: null,
    dailyData: null,
    yearlyData: null,
};

const monthDayReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case INIT_DAILY_REPORT_REQUEST:
        case INIT_YEARLY_REPORT_REQUEST:
            return { ...state, isLoading: true, error: null };
        case SET_DAILY_REPORT:
            return { ...state, isLoading: false, dailyData: action.payload, error: null };
        case SET_YEARLY_REPORT:
            return { ...state, isLoading: false, yearlyData: action.payload, error: null };
        case ERROR_DAILY_REPORT:
        case ERROR_YEARLY_REPORT:
            return { ...state, isLoading: false, error: action.payload };
        default:
            return state;
    }
};

export default monthDayReportReducer;
